<div id="popup_makeCenter">
  <div id="popup_makeCenter_close" (click)="onCloseClick($event)"></div>
  <div class="pop-up-container">
    <img
      class="menu_warnings"
      src="./assets/images/lobby_sprite_images/common/menu_sprite_images/menu_warnings.webp"
    />
    <img
      class="Banner_crop"
      src="./assets/images/common/gold banner_crop@2x.webp"
    />
    <div class="lang-specific-text-content_LANG01118">
      <span
        class="lang-specific-font-name-menu lang-specific-right_to_left_direction playnow_text"
        >{{ 'LANG01118' | translate }}{{ ' ' }}{{ errorMessageCode }}</span
      >
    </div>
    <img
      class="popupimg"
      src="./assets/images/common/quick_start_gold_bg.webp"
    />
    <img
      class="popupimg_quickstart_banner"
      src="./assets/images/lobby_sprite_images/lang_sprite_images/{{
        currentLanguage
      }}_fcg/{{ currentLanguage }}_quickstart_banner@2x.webp"
    />

    <img
      class="separator_horizontal_img_top"
      src="./assets/images/common/separator_horizontal@2x.webp"
    />
    <img
      class="separator_horizontal_img_bottom"
      src="./assets/images/common/separator_horizontal@2x.webp"
    />

    <div class="lang-specific-text-content_LANG00860">
      <span
        class="lang-specific-font-name-menu lang-specific-right_to_left_direction playnow_text"
        >{{ headerMessageText | translate }}
      </span>
    </div>

    <div class="lang-specific-text-content_LANG01100">
      <span
        class="lang-specific-font-name-menu lang-specific-right_to_left_direction playnow_text"
        >{{ descriptionMessageText | translate }}</span
      >
    </div>
    <img
      class="separator_horizontal_img_playnow"
      src="./assets/images/common/separator_horizontal@2x.webp"
    />
    <img
      class="closeiconImg"
      src="./assets/images/lobby_sprite_images/common/menu_sprite_images/close.webp"
      (click)="onCloseClick($event)"
    />
    <div
      class="lang-specific-text-content-insuff-LD"
      (click)="onCloseClick(LDSeatsObj)"
    >
      <span
        class="lang-specific-font-name-menu lang-specific-right_to_left_direction playnow_text"
        >{{ 'LANG00504' | translate }}
      </span>
    </div>
  </div>
</div>
